/**
 * Diccionario único de etiquetas legibles (español) del módulo de Llamadas.
 *
 * Regla: ninguna tabla, panel o tarjeta debe pintar una llave de enum en inglés.
 * Todos los componentes de `pages/call/**` deben importar de aquí en vez de
 * declarar sus propios mapas.
 */

/** Devuelve la etiqueta del diccionario; si la llave es desconocida, la deja tal cual. */
export function labelFrom(
  dict: Readonly<Record<string, string>>,
  key: string | null | undefined,
  fallback = '—'
): string {
  if (key === null || key === undefined || key === '') return fallback;
  return dict[key] ?? key;
}

export const CALL_STATUS_LABELS: Readonly<Record<string, string>> = {
  INITIATED: 'Iniciada',
  IN_PROGRESS: 'En curso',
  COMPLETED: 'Completada',
  FAILED: 'Falló',
  BUSY: 'Ocupado',
  NO_ANSWER: 'Sin respuesta',
  UNKNOWN: 'Desconocido'
};

export const CALL_DIRECTION_LABELS: Readonly<Record<string, string>> = {
  INBOUND: 'Entrante',
  OUTBOUND: 'Saliente'
};

export const AGENT_PRESENCE_LABELS: Readonly<Record<string, string>> = {
  AVAILABLE: 'Disponible',
  BUSY: 'Ocupado',
  ON_BREAK: 'En pausa',
  OFFLINE: 'Desconectado'
};

export const PHONE_NUMBER_TYPE_LABELS: Readonly<Record<string, string>> = {
  LOCAL: 'Local',
  TOLL_FREE: 'Gratuito (800)',
  MOBILE: 'Móvil',
  VOIP: 'VoIP'
};

export const TRANSFER_TYPE_LABELS: Readonly<Record<string, string>> = {
  AGENT: 'Agente',
  TEAM: 'Equipo'
};

export const CALL_PROVIDER_LABELS: Readonly<Record<string, string>> = {
  TWILIO: 'Twilio'
};

export const NO_AGENT_FALLBACK_LABELS: Readonly<Record<string, string>> = {
  HANGUP: 'Colgar la llamada',
  VOICEMAIL: 'Enviar a buzón de voz'
};

/** Estado de los negocios abiertos que devuelve el contexto CRM de la llamada. */
export const CALL_CONTEXT_DEAL_STATUS_LABELS: Readonly<Record<string, string>> = {
  OPEN: 'Abierto',
  WON: 'Ganado',
  LOST: 'Perdido'
};
